import { Link } from "react-router-dom";
import escudo from "../Ingresos/escudo";

const NotFound = () => {
  const imagen=escudo()
    return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
        <img src={imagen} alt="" />
      <h1>404 - Página no encontrada</h1>
      <p>La página que intentaste acceder no existe.</p>
      <Link to="/" style={{ color: "#3085d6", textDecoration: "underline" }}>
        Volver al inicio
      </Link>
    </div>
  );
};

export default NotFound;
